import { render } from "./Melody.vue?vue&type=template&id=a412db46&scoped=true"
import script from "./Melody.vue?vue&type=script&lang=js"
export * from "./Melody.vue?vue&type=script&lang=js"

import "./Melody.vue?vue&type=style&index=0&id=a412db46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a412db46"]])

export default __exports__